import { DateFunctions } from "../static/date-functions";
import { CommonValues } from "../static/CommonValues";

export class DispatchOrder 
{
    constructor(data: DispatchOrder = null) {
        if (data != null) {
            this.orderId = data.orderId;
            this.orderNumber = data.orderNumber;
            this.dispatchNumber = data.dispatchNumber;
            this.isSubContract = data.isSubContract;
            this.orderStatusName = data.orderStatusName;
            this.dispatchId = data.dispatchId;
            this.orderStatusId = data.orderStatusId;
            this.supplierId = data.supplierId;
            this.supplierName = data.supplierName;
        }

    }
 orderId: any;
 orderNumber: string;
 dispatchNumber: string;
 isSubContract: boolean ;
 orderStatusName: string;
 dispatchId: any;
 orderStatusId: any;
 supplierId: any;
 supplierName: string;
    get value(): any {
        return this.orderId;
    }
    get description(): string {
        return this.orderNumber + " - " + this.orderStatusName + (this.isSubContract ? " - Sub: " + this.supplierName : "");
    }
}